export const USER_KEY = "ELEVATE-Key"
export const USER_ROLE = "ELEVATE-Role"
export const USER_PERMISSIONS = "ELEVATE-Permissions"
export const USER_TYPE_OF_ACCOUNT = "ELEVATE-Type_Of_Account"
export const USER_FULL_NAME = "ELEVATE-USER_FULL_NAME"